import type { MetricFormat } from '../types';

export type BarColorToken = 'primary' | 'info' | 'warning' | 'error' | 'success' | 'grey';

export const formatMetricValue = (
  value: number | string,
  format?: MetricFormat,
): string => {
  if (typeof value === 'string') return value;
  switch (format) {
    case 'percent':
      return Number.isInteger(value) ? `${value}%` : `${value}%`;
    case 'pp':
      return `${value}pp`;
    case 'days':
      return `${value} days`;
    case 'currency':
      return `$${value.toLocaleString()}`;
    case 'count':
    default:
      return value.toLocaleString();
  }
};

export const resolveBarColor = (
  token: BarColorToken | string | undefined,
  palette: {
    primary: { main: string };
    info: { main: string };
    warning: { main: string };
    error: { main: string };
    success: { main: string };
    // MUI `palette.grey` is a `Color` type (not `Record<number,string>`), so keep it loose.
    grey?: Record<number, string> | { [key: number]: string } | any;
  },
): string => {
  switch (token) {
    case 'info':
      return palette.info.main;
    case 'warning':
      return palette.warning.main;
    case 'error':
      return palette.error.main;
    case 'success':
      return palette.success.main;
    case 'grey':
      return palette.grey?.[500] ?? '#9e9e9e';
    case 'primary':
    default:
      return palette.primary.main;
  }
};
